import classNames from 'classnames';
import { useFormattedFormGroupLabel } from 'components/shared/FormGroup/useFormatFormGroupLabel';
import { FC } from 'react';

import type { CommonFormGroupProps } from './model';

interface HorizontalFormGroupProps extends CommonFormGroupProps {
  labelSize?: number;
}

export const HorizontalFormGroup: FC<HorizontalFormGroupProps> = ({
  inputId,
  label,
  labelContent,
  children,
  className,
  labelSize = 4,
  workspaceType,
}) => {
  const labelText = useFormattedFormGroupLabel({ label, workspaceType, inputId });
  const contentSize = 12 - labelSize;
  return (
    <div className={classNames('form-group row', className)} data-e2e={inputId} id={inputId}>
      <label htmlFor={inputId} className={`col-lg-${labelSize} col-form-label`}>
        {labelText}
        {labelContent}
      </label>
      <div className={`col-lg-${contentSize} col-form-content d-flex flex-column justify-content-center`}>
        {children}
      </div>
    </div>
  );
};

HorizontalFormGroup.displayName = 'HorizontalFormGroup';
